<!-- <div class="overlay" [class.visible]="isVisible" (click)="closeSidebar(false)"></div> -->
<div class="overlay" [class.visible]="isVisible" (click)="closeSidebar(false)"></div>
<div class="sidebar" [class.visible]="isVisible" >
   <div class="order-container">
      <div>
      <header>
         <div class="back-button">
            <i (click)="closeSidebar(false)" class="material-icons" style="color: black;font-weight: bold; cursor: pointer;">arrow_back</i>
            <div class="title">My Request Wishlist</div>
         </div>
      </header>
      <div class="spares-card">
        <div class="logo">
          <img src="{{vehicleData.imageUrlPath}}" alt="Logo" />
        </div>
        <div class="details">
          <p><strong>{{vehicleData.model}}, {{vehicleData.fuel}}</strong></p>
          <p>{{vehicleData.variant}}, [{{vehicleData.year}}]</p>
          <p>{{vehicleData.registrationNumber}}</p>
        </div>
      </div>
         </div>
        </div>
        <div *ngIf="wishlistItems?.length>0">
            <p class="requested">Request Wishlist</p>
            <div style="    margin-bottom: 72px;">
            <div *ngFor="let item of wishlistItems">
            <div class="added">
              <div>
                <div style="font-weight: bold;font-size: 14px;">{{ getSuggestionName(item.name) | titlecase }}</div>
                <div style="font-size: 11px;">{{ item.name | titlecase }}</div>
              </div>

                <div class="wishlist-quantity">
                    <mat-icon (click)="decreaseQty(item)">remove</mat-icon>
                    <span style="color: #144579;padding-left: 10px;margin-bottom: 4px;">{{ getItemQuantity(item.name) || 1 }}</span>
                    <mat-icon (click)="increaseQty(item)">add</mat-icon>
                </div>
                </div>
            </div>
            </div>
            <div class="request" (click)="createRequest()">
                <div class="place">
                    Place Request
                </div>
            </div>
        </div>
        <div *ngIf="wishlistItems?.length<=0" class="no-match">
            <div class="empty-item">
                <img style="    padding: 0px 0px 27px 10px;width: 82%;"src="{{emptyImg}}" alt="" />
                <div class="sec1">No spares added yet!</div>
                <div class="sec2">Your request wishlist is empty</div>
                <div class="sec2">Your car parts are just a click away</div>
                <button class="back" (click)="closeSidebar(false)">Go Back</button>
            </div>
        </div>
</div>
<div class="popup" *ngIf="isPopupOpen">
    <div class="popup-content order-success-sec">
      <!-- <button mat-button (click)="closePopup()">Close</button> -->
      <img src="{{ successIcon }}" alt="Success Icon">
      <!-- <button class="close-popup" (click)="closePopup()">×</button> -->
      <mat-icon class="close-popup" (click)="closePopup()">close</mat-icon>

      <h3>Request Created!</h3>
      <p class="order-label"><span class="order-id">Request ID  {{requestId}}</span></p>
      <p class="date"><span>{{requestCreated | date:'dd MMM yyyy, hh:mm a'}}</span></p>
      <p class="thank-you">Let us deliver an awesome experience!</p>
      <button class="goto-order" (click)="requestPage()">Track My Request </button>
    </div>
  </div>